import * as React from 'react';
import {Divider as MuiDivider,} from '@material-ui/core';

export default function Divider({ getFieldState = undefined, ...props }) {
  return <MuiDivider />;
}
  
